import { StickyContext } from '@buzzfeed/react-components';

export default StickyContext;
